<template>
  <b-card
    v-if="data"
    no-body
    class="card-statistics"
  >
    <b-card-header>
      <b-card-title>Order Statistics</b-card-title>
<!--      <b-card-text class="font-small-2 mr-25 mb-0">-->
<!--        Updated 1 month ago-->
<!--      </b-card-text>-->
    </b-card-header>
    <b-card-body class="statistics-body">
      <b-row>
        <b-col
          xl="3"
          sm="6"
          v-for="item in data"
          :key="item.icon"
          :class="item.customClass"
        >
          <b-media no-body>
            <b-media-aside

              class="mr-2"
            >
              <b-avatar
                size="48"
                :variant="item.color"
              >
                <feather-icon
                  size="24"
                  :icon="item.icon"
                />
              </b-avatar>
            </b-media-aside>
            <b-media-body class="my-auto">
              <h4 class="font-weight-bolder mb-0">
                {{ item.title }}
              </h4>
              <b-card-text class="font-small-3 mb-0">
                {{ item.subtitle }}
              </b-card-text>
            </b-media-body>
          </b-media>
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BCardHeader, BCardTitle, BCardText, BCardBody, BRow, BCol, BMedia, BMediaAside, BAvatar, BMediaBody,
} from 'bootstrap-vue'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardText,
    BCardBody,
    BMedia,
    BAvatar,
    BMediaAside,
    BMediaBody,
  },
  props: {

  },
  data(){
    return{
      data: [
      {
        icon: 'ArchiveIcon',
        color: 'light-primary',
        title: '230k',
        subtitle: 'All Orders',
        customClass: 'mb-2 mb-xl-0',
      },
      {
        icon: 'SettingsIcon',
        color: 'light-info',
        title: '8.549k',
        subtitle: 'Processing',
        customClass: 'mb-2 mb-xl-0',
      },
      {
        icon: 'TruckIcon',
        color: 'light-danger',
        title: '1.423k',
        subtitle: 'Shipped',
        customClass: 'mb-2 mb-sm-0',
      },
      {
        icon: 'ThumbsUpIcon',
        color: 'light-success',
        title: '9.745k',
        subtitle: 'Delivered',
        customClass: '',
      },
    ],
    }
  }
}
</script>
